import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createSlots as _createSlots, isRef as _isRef } from "vue"

const _hoisted_1 = { style: {"width":"320px"} }
const _hoisted_2 = {
  key: 0,
  class: "v-participants-dropdown__team"
}

import { computed, ref } from 'vue';
import { name } from '@/utils/name';
import { useVModel } from '@vueuse/core';
import { useProgramsStore } from '@/stores/programs';


export default /*#__PURE__*/_defineComponent({
  __name: 'VParticipantsDropdown',
  props: {
    modelValue: null,
    label: null,
    items: null,
    multiple: { type: Boolean },
    search: { type: Boolean },
    teams: null
  },
  emits: [ "update:modelValue" ],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: any, label?: string, items?: any[], multiple?: boolean, search?: boolean, teams?: any[] }




const modelValue = useVModel(props, "modelValue", emit)

const searchValue = ref("")

const showItem = (item: any) => {
  if (searchValue.value === "") return true
  return name(item).toLowerCase().includes(searchValue.value.toLowerCase())
}


return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_VSelect = _resolveComponent("VSelect")!

  return (_openBlock(), _createBlock(_component_VSelect, {
    modelValue: _unref(modelValue),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
    label: props.label,
    variant: "outlined",
    items: props.items,
    multiple: props.multiple,
    "item-value": "id",
    clearable: "",
    "closable-chips": "",
    class: "v-participants-dropdown"
  }, _createSlots({
    item: _withCtx(({ props: listProps, item, index }) => [
      (index === 0 && props.search)
        ? (_openBlock(), _createBlock(_component_v_text_field, {
            key: 0,
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
            "prepend-inner-icon": "mdi-magnify",
            placeholder: "Поиск участника",
            variant: "outlined",
            "hide-details": "",
            class: "search-input mx-4 my-2"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (showItem(item.raw))
        ? (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({ key: 1 }, listProps, {
            class: "team-students__item",
            title: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (searchValue.value = ''))
          }), _createSlots({
            prepend: _withCtx(() => [
              _createVNode(_component_v_avatar, {
                class: "mr-2",
                image: item.raw.avatar,
                color: "surface-variant",
                size: 32
              }, null, 8, ["image"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(name)(item.raw)), 1),
              (props.teams)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.teams.find(team => team.id === item.raw.teamId)?.name), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (props.multiple)
              ? {
                  name: "append",
                  fn: _withCtx(({ isActive }) => [
                    _createVNode(_component_v_checkbox_btn, {
                      "model-value": isActive,
                      color: "primary"
                    }, null, 8, ["model-value"])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1040))
        : _createCommentVNode("", true)
    ]),
    menu: _withCtx(() => [
      _createTextVNode(" test ")
    ]),
    _: 2
  }, [
    (props.multiple)
      ? {
          name: "chip",
          fn: _withCtx(({ item, props }) => [
            _createVNode(_component_v_chip, _mergeProps({ class: "v-participant-chip mb-2" }, props), {
              default: _withCtx(() => [
                _createVNode(_component_v_avatar, {
                  image: item.raw?.avatar,
                  class: "mr-1"
                }, null, 8, ["image"]),
                _createTextVNode(" " + _toDisplayString(_unref(name)(item.raw)), 1)
              ]),
              _: 2
            }, 1040)
          ]),
          key: "0"
        }
      : {
          name: "chip",
          fn: _withCtx(({ item, props }) => [
            _createElementVNode("div", { class: "d-flex align-center mt-n4" }, [
              _createVNode(_component_v_avatar, {
                size: "30",
                image: item.raw?.avatar,
                class: "mr-2"
              }, null, 8, ["image"]),
              _createTextVNode(" " + _toDisplayString(_unref(name)(item.raw)), 1)
            ])
          ]),
          key: "1"
        }
  ]), 1032, ["modelValue", "label", "items", "multiple"]))
}
}

})